

export default {
  name: "OrdersBoxMobile",
  components: {
  },
  props: {
  },
  mounted() {
    let t = this;
    t.initUI();
  },
  created() {
    let t = this;

    let d = new Date();
    d.setDate(d.getDate() - 1);
    t.defaultDate = d;
    t.historyDate = d.format('yyyy-MM-dd');
    t.loadStats();
    t.loadData();
  },
  activated: function (el) {
  },
  deactivated() {
  },
  methods: {

    autoSelect() {
      let t = this;

      let b = true;

      t.list.log.forEach(item => {
        if (item.type == t.type && !item.selected) {
          b = false;
        }
      });

      t.allIsSelected = b;
    },
    selectAll() {
      let t = this;

      t.list.log.forEach(item => {
        if (item.type == t.type) {
          item.selected = t.allIsSelected;
        }
      });

    },

    loadStats() {
      let t = this;

      axios.get('orderLog/stats').then(res => {
        if (res.data.status == 1) {
          t.stats = res.data.options.stats;
        }
      });

      axios.get('room?sample=name').then(res => {
        if (res.data.status == 1) {
          let arr = res.data.options.items;
          t.list.room = arr;
          t.dict.room = listToDict(t.list.room);
        }
      });

    },

    loadData() {
      let t = this;

      t.allIsSelected = false;
      t.list.log.clear();

      let p = {
        '_with': 'tasks,order,confirmor',
        'status': t.type == 4 ? 1 : 0,
      };

      if (t.type == 4) {
        p.confirmed_at = t.historyDate + ',' + t.historyDate
      }

      axios.get('orderLog', { params: p }).then(res => {
        if (res.data.status == 1) {
          let arr = res.data.options.items;
          arr.forEach(item => {
            item.selected = false;
            if (item.before_data)
              item.before_data = JSON.parse(item.before_data);
          });
          t.list.log = arr;
        }
      });

    },
    initUI() {

    },
    confirm() {

      let t = this;

      let ids = [];
      let items = [];

      t.list.log.forEach(item => {
        if (item.selected) {
          ids.push(item.id);
          items.push(item);
        }
      });

      if (ids.length == 0) {
        A.err('少なくとも1つの予約を確認する。');
        return;
      }

      axios.post('orderLog/batchConfirm', { ids: ids.join(',') }).then(res => {
        if (res.data.status == 1) {
          items.forEach(item => {
            t.list.log.remove(item);
          });
          t.loadStats();
        }
      });

    },
    close() {
      this.show = false;
      this.$emit('input', false);
    },

    onSelectDate(d) {

      let t = this;

      let date = d.format('yyyy-MM-dd');

      if (t.historyDate == date)
        return;

      t.historyDate = date;

      t.showDatePopover = false;

      t.loadData();
    },

    minusDate() {
      let t = this;

      let d = new Date(t.historyDate.replace(/-/g, '/'));

      d.setDate(d.getDate() - 1);

      t.historyDate = d.format('yyyy-MM-dd');

      t.defaultDate = d;

      t.loadData();

      t.stopPropagation();
    },

    plusDate() {
      let t = this;

      let d = new Date(t.historyDate.replace(/-/g, '/'));

      d.setDate(d.getDate() + 1);

      t.defaultDate = d;

      t.historyDate = d.format('yyyy-MM-dd');

      t.loadData();

      t.stopPropagation();
    },

    scrollToDate(date) {
      this.$refs.calendar.scrollToDate(date);
    },
  },
  data() {
    return {
      allIsSelected: false,
      defaultDate: null,
      historyDate: null,
      showDatePopover: false,
      maxDate: new Date(),
      minDate: new Date('2023/10/15'),
      type: 2,
      stats: {
        new: 0,
        cancel: 0,
        update: 0,
        history: 0,
      },
      list: {
        log: [],
        room: []
      },
      dict: {
        room: {}
      }
    };
  },
  computed: {
    filteredLogs() {
      let t = this;
      return t.list.log.filter((item) => {
        if (item.type == t.type || t.type == 4) {
          return true;
        }
        return false;
      });
    },
  }
};
